'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colord = require('colord');
var cmykPlugin = require('colord/plugins/cmyk');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var cmykPlugin__default = /*#__PURE__*/_interopDefaultCompat(cmykPlugin);

colord.extend([
    cmykPlugin__default.default
]);
/**
 * Convert CMYK to HEX
 * @param cmyk CmykColor
 * @returns HexColor
 */ const convertCmykToHex = (cmyk)=>{
    return colord.colord(cmyk).toHex();
};
/**
 * Convert 3 digit HEX to 6 digit HEX
 * @param hex HexColor
 * @returns HexColor
 */ const convertHex3toHex6 = (hex)=>{
    const value = hex.replace('#', '');
    if (value.length === 3) {
        const newHex = value.split('') // eslint-disable-line unicorn/prefer-spread
        .map(function(v) {
            return v + v;
        }).join('');
        return `#${newHex}`;
    }
    return `#${value}`;
};
/**
 * Convert HEX to HSL
 * @param hex HexColor
 * @returns HslColor
 */ const convertHexToHsl = (hex)=>{
    const { h , l , s  } = colord.colord(hex).toHsl();
    return {
        h,
        s,
        l
    };
};
/**
 * Convert HEX to RGB
 * @param hex HexColor
 * @returns RgbColor
 */ const convertHexToRgb = (hex)=>{
    const { b , g , r  } = colord.colord(hex).toRgb();
    return {
        r,
        g,
        b
    };
};
/**
 * Convert HSL to HEX
 * @param hsl HslColor
 * @returns HexColor
 */ const convertHslToHex = (hsl)=>{
    return colord.colord(hsl).toHex();
};
/**
 * Convert HSL to RGB
 * @param hsl HslColor
 * @returns RgbColor
 */ const convertHslToRgb = (hsl)=>{
    const { b , g , r  } = colord.colord(hsl).toRgb();
    return {
        r,
        g,
        b
    };
};
/**
 * Convert RGB to HEX
 * @param rgb RgbColor
 * @returns HexColor
 */ const convertRgbToHex = (rgb)=>{
    return colord.colord(rgb).toHex();
};
/**
 * Convert RGB to HSL
 * @param rgb RgbColor
 * @returns HslColor
 */ const convertRgbToHsl = (rgb)=>{
    const { h , l , s  } = colord.colord(rgb).toHsl();
    return {
        h,
        s,
        l
    };
};
/**
 * Check if a color is a HEX color
 * @param value UnknownColor
 * @returns boolean
 */ const isHexColor = (value)=>{
    return colord.getFormat(value) === 'hex';
};
/**
 * Check if a color is an HSL color
 * @param value UnknownColor
 * @returns boolean
 */ const isHslColor = (value)=>{
    return colord.getFormat(value) === 'hsl';
};
/**
 * Check if a color is a RGB color
 * @param value UnknownColor
 * @returns boolean
 */ const isRgbColor = (value)=>{
    return colord.getFormat(value) === 'rgb';
};
/**
 * Check if a color is a valid HEX, RGB, or HSL color
 * @param value AnyColor
 * @returns boolean
 */ const isValidColor = (value)=>{
    return colord.colord(value).isValid();
};
/**
 * Convert CMYK color to string
 * @param cmyk CmykColor
 * @returns string
 */ const convertCmykToString = (cmyk)=>{
    if (!cmyk) return '';
    return `C${cmyk.c}, M${cmyk.m}, Y${cmyk.y}, K${cmyk.k}`;
};
/**
 * Convert HEX color to CSS string (enforces beginning hash)
 * @param hex HexColor
 * @returns string
 */ const convertHexToString = (hex)=>{
    if (!hex) return '';
    return hex.startsWith('#') ? hex : `#${hex}`;
};
/**
 * Convert HSL color to CSS string
 * @param hsl HslColor
 * @returns string
 */ const convertHslToString = (hsl)=>{
    if (!hsl) return '';
    return `hsl(${hsl.h} ${hsl.s}% ${hsl.l}%)`;
};
/**
 * Convert RGB color to CSS string
 * @param rgb RgbColor
 * @returns string
 */ const convertRgbToString = (rgb)=>{
    if (!rgb) return '';
    return `rgb(${rgb.r},${rgb.g},${rgb.b})`;
};

exports.convertCmykToHex = convertCmykToHex;
exports.convertCmykToString = convertCmykToString;
exports.convertHex3toHex6 = convertHex3toHex6;
exports.convertHexToHsl = convertHexToHsl;
exports.convertHexToRgb = convertHexToRgb;
exports.convertHexToString = convertHexToString;
exports.convertHslToHex = convertHslToHex;
exports.convertHslToRgb = convertHslToRgb;
exports.convertHslToString = convertHslToString;
exports.convertRgbToHex = convertRgbToHex;
exports.convertRgbToHsl = convertRgbToHsl;
exports.convertRgbToString = convertRgbToString;
exports.isHexColor = isHexColor;
exports.isHslColor = isHslColor;
exports.isRgbColor = isRgbColor;
exports.isValidColor = isValidColor;
//# sourceMappingURL=color.js.map
